export function initGTM(gtmId: string): void {
  console.log('[GTM] Initializing with ID:', gtmId)
  ;(window as any).dataLayer = (window as any).dataLayer || []
  ;(window as any).dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js'
  })

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`
  document.head.appendChild(script)
  console.log('[GTM] Script loaded')
}

export function sendGTMEvent(event: string, data?: Record<string, any>): void {
  ;(window as any).dataLayer = (window as any).dataLayer || []
  const eventData = {
    event,
    ...data
  }

  console.log('[GTM] Sending event:', eventData)
  ;(window as any).dataLayer.push(eventData)
}

export function isInIframe(): boolean {
  try {
    return window.self !== window.top
  } catch {
    return true
  }
}
